import { useTranslation } from 'react-i18next'
import keys from 'lodash/keys'

import { IActivity } from 'cat-shared/utils'
import { useGetUserActivity } from 'client/api'
import { humanizeFromToNow, getQuestionUrl } from 'client/services'
import { useAppContext } from 'client/hooks'

import {
  AppButton,
  AppDivider,
  AppHeader,
  AppIcon,
  AppLoader,
  AppParagraph,
  IconName,
} from 'client/ui-building-blocks'

import styles from './activity-list.module.scss'

const CONFIG = {
  createdAt: 'WRITE',
  answeredAt: 'CHECK',
  reportedAt: 'BUG',
} as Record<string, IconName>

const ActivityList = () => {
  const { t, i18n } = useTranslation()

  const { setShowAppNotifications } = useAppContext()

  const { data: activityData, isLoading, isFetching } = useGetUserActivity()

  const onCloseBtnClick = () => {
    setShowAppNotifications(false)
  }

  const renderActivityItem = (item: IActivity, i: number) => {
    const onQuestionLinkClick = e => {
      e.stopPropagation()
      window.open(getQuestionUrl(item._id.toString()), '_blank')
    }

    const fieldNames = keys(CONFIG)
    const fieldName = keys(item).find(k => fieldNames.includes(k) && item[k])

    const actionText =
      t('profilePage.activity', { returnObjects: true })[fieldName] +
      ' ' +
      humanizeFromToNow(
        item.createdAt || item.answeredAt || item.reportedAt,
        i18n.language
      )

    return (
      <div key={i} className={styles.activityItem} onClick={onQuestionLinkClick}>
        <div className={styles.textContent}>
          <div className={styles.linkColumn}>
            <AppHeader text={item.text} color="light" />
          </div>
          <div className={styles.actionColumn}>
            <AppParagraph text={actionText} color="secondary" size="small" />
          </div>
        </div>
        <div className={styles.iconContainer}>
          <AppIcon name={CONFIG[fieldName]} size="small" variant="info" />
        </div>
      </div>
    )
  }

  return (
    <AppLoader size="mini" active={isLoading || isFetching}>
      {activityData?.data?.length ? (
        <>
          {activityData.data.map(renderActivityItem)}
          <AppDivider size="xsmall" />
          <AppButton
            text={t('common.buttons.close')}
            position="center"
            onClick={onCloseBtnClick}
          />
          <AppDivider size="xsmall" />
        </>
      ) : (
        <>
          <AppDivider size="small" />
          <AppParagraph text="Empty" size="small" color="light" centered />
        </>
      )}
    </AppLoader>
  )
}

export default ActivityList
